import request from '@/utils/request'

// 查询土地分页
export function pageLand(data) {
  return request({
    url: '/cloudplant/land/page',
    method: 'post',
    data: data
  })
}

// 查询土地列表
export function listLand(query) {
  return request({
    url: '/cloudplant/land/list',
    method: 'get',
    params: query
  })
}

// 查询土地详情
export function getLand(data) {
  return request({
    url: '/cloudplant/land/detail',
    method: 'get',
    params: data
  })
}

// 新增土地
export function addLand(data) {
  return request({
    url: '/cloudplant/land/add',
    method: 'post',
    data: data
  })
}

// 修改土地
export function updateLand(data) {
  return request({
    url: '/cloudplant/land/edit',
    method: 'post',
    data: data
  })
}

// 删除土地
export function delLand(data) {
  return request({
    url: '/cloudplant/land/delete',
    method: 'post',
    data: data
  })
}

// 分配监控
export function assignMonitor(data) {
  return request({
    url: '/cloudplant/land/assignMonitor',
    method: 'post',
    params: data
  })
}
